import { Label } from '../../ui/label';
import { cn } from '../../../lib/cn';
import { TIPO_SEQUENZA } from '../../../types/automazioni.types';

interface SceltaTipoSequenzaProps {
  servizio: boolean;
  onChange: (servizio: boolean) => void;
}

/**
 * Cosa manda la sequenza. Le informazioni sul corso arrivano anche a chi non
 * ha accettato le promozioni: per questo, scegliendole, si dice chiaro che
 * dentro non ci va nient'altro.
 */
export function SceltaTipoSequenza({ servizio, onChange }: SceltaTipoSequenzaProps) {
  const opzioni = [
    { valore: false, ...TIPO_SEQUENZA.promozioni },
    { valore: true, ...TIPO_SEQUENZA.servizio },
  ];

  return (
    <div>
      <Label className="text-xs">Cosa manda</Label>
      <div className="space-y-1.5 mt-1.5">
        {opzioni.map((o) => (
          <button
            key={String(o.valore)}
            type="button"
            onClick={() => onChange(o.valore)}
            aria-pressed={servizio === o.valore}
            className={cn(
              'w-full text-left px-3 py-2 rounded-lg border transition-colors',
              servizio === o.valore
                ? 'border-primary-400 bg-primary-50/50'
                : 'border-gray-200 hover:border-gray-300'
            )}
          >
            <span className="block text-xs font-semibold text-gray-900">{o.label}</span>
            <span className="block text-[11px] text-neutral-400 mt-0.5 leading-relaxed">
              {o.spiegazione}
            </span>
          </button>
        ))}
      </div>
      {servizio && (
        <p className="text-[11px] text-amber-800 bg-amber-50 border border-amber-100 rounded-md px-2.5 py-1.5 mt-2 leading-relaxed">
          Dentro solo informazioni pratiche sul corso. Niente offerte e niente altri corsi: a chi
          non ha accettato le promozioni sarebbe spam, e il Garante lo sanziona.
        </p>
      )}
    </div>
  );
}
